import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
/* eslint-disable import/no-unresolved */
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

export default function createReduxStore(...reducersObjects) {
  const middlewares = [thunk];
  const rootReducer = {};

  if (process.env.NODE_ENV === 'development') {
    middlewares.push(createLogger({
      collapsed: true,
      duration: true,
      timestamp: false,
    }));
  }

  reducersObjects.forEach((reducerObject) => {
    Object.keys(reducerObject).forEach((reducerKey) => {
      if (Object.prototype.hasOwnProperty.call(rootReducer, reducerKey)) {
        throw new Error(`You already registered reducer with this key: "${reducerKey}". Check your code!`);
      }

      rootReducer[reducerKey] = reducerObject[reducerKey];
    });
  });

  return createStore(
    combineReducers(rootReducer),
    composeWithDevTools(applyMiddleware(...middlewares))
  );
}

